import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import foreignBusinessContactItemValidator from './validators/item';
import { ForeignBusinessContactModel } from './types';

// TODO: Rename (Drop S)
const foreignBusinessContactValidator: ValidateJSModel<ForeignBusinessContactModel> = {
  HasForeignContact: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasForeignContact?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignBusinessContactItemValidator },
      };
    }

    return {};
  },
};

export default foreignBusinessContactValidator;
